import {
  FormControlLabel,
  Grid,
  Typography,
  WithStyles,
  makeStyles,
  Checkbox
  //CircularProgress
} from '@material-ui/core'
import DateRangeIcon from '@material-ui/icons/DateRange'
import { useState, useEffect } from 'react'
import { withTranslation, WithTranslation } from 'react-i18next'
import { connect } from 'react-redux'
import { Field, formValueSelector, reduxForm } from 'redux-form'
import ErrorMessage from '../../../components/Error/ErrorMessage'
import {
  ReduxFormField,
  ReduxDatePicker
} from '../../../components/FormInput/ReduxWrappers'
// import TermsFrame from '../../../components/TernsFrame/TermsFrame'
import {
  onlyNumsAndDecimals
} from '../../../libs/normalize/information'
import {
  selectApartmentById,
  selectBeforeLoginApartment
} from '../../../selectors/apartments'
import { selectContentIdFromPathname } from '../../../selectors/router'
import { selectIsMobile } from '../../../selectors/users'
import { ReduxForm } from '../../../types/forms'
import {
  WaterFeeBasis,
  RentPeriodOptions,
  SecurityDepositOptions,
  NoticeTimeOptions,
  Parking,
  AnnouncementTypeOptions
} from '../../../types/propValues/apartments'
// import { ShowingTypes } from '../../../types/showings'
import { StateInterface } from '../../../types/states'

import {
  required,
  // requiredFalsyString,
  greaterThanAvailableFrom,
  noSpacesPhoneNum,
  validateEmail,
  validatePassword,
  noSpaceValue,
  validatePhoneNumber,
  isInvalidCharacters,
  requiredCheckbox
} from '../../../utils/validation/forms'
import { MyApartmentRadio, MyInput } from '../../NewApplication/Fields'
import { BackButton } from '../Stepper/BackButton'
import NextStepButton from '../Stepper/NextStepButton'
import Suggest from '../Stepper/Steps/Suggest'
import SubmitButton from '../Stepper/SubmitButton'
import { getValuesAndLabels } from './values/apartmentProperties'

const useStyles = makeStyles({
  Accordion: {
    marginTop: '15px'
  },
  panelDetails: {
    display: 'block',
    height: '300px',
    padding: 0,
    overflow: 'hidden'
  },
  panelTitle: {
    marginTop: '15px',
    backgroundColor: '#bdbdbd'
  },
  checkboxGroup: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: '12px',
    marginTop: '12px',
    marginBottom: '12px'
  },
  checkboxLabel: {
    margin: 0,
    alignItems: 'center',
    '& .MuiCheckbox-root': {
      padding: 0,
      marginRight: '12px',
      color: '#4f9b44'
    }
  },
  checkboxControl: {
    padding: 0,
    marginRight: '8px',
    color: '#4f9b44'
  },
  checkboxText: {
    lineHeight: 1.5
  },
  announcementInfoBox: {
    marginTop: '12px',
    marginBottom: '20px',
    padding: '16px',
    backgroundColor: '#E2EBFD',
    borderRadius: '8px',
    textAlign: 'left',
    fontSize: '14px',
    fontWeight: 500
  },
  contactSubheading: {
    fontFamily: 'CircularRegular',
    fontWeight: 400,
    marginTop: '12px'
  },
  vuokraoviCollateralCheckBoxContainer: {
    alignItems: 'center',
    marginTop: '12px'
  },
  buttonGap: {
    marginBottom: '32px'
  }
})
interface ApartmentConfirmationFormProps
  extends WithStyles,
  WithTranslation,
  ReduxForm {
  updateApartmentConfirmation: (arg: any) => any
  isDisabled: boolean
  isTemporaryRentPeriod: boolean
  isFormerlyValid: boolean
  waterFeeBasis: WaterFeeBasis | undefined
  waterFeeAdornment: string
  rentPrice: number
  rentPeriod: string
  announcementType: string
  confirm: boolean
  securityDeposit: string
  showParkingFee: boolean
  showSecurityDepositAmount: boolean
  isSVAMember: boolean
  isBeforeLogin?: boolean
  createdAt: number | undefined
  currentStep: any
  doStepBack: any
  isMobile: any
  beforeLogin?: boolean
  notes?: string
  availableUntilDate?: any
  availableFromDate?: any
  vuokraoviCollateral?: boolean
  name: string
  phoneNumber: string
  email: string
  password: string
}

// const getWaterFeeAdornment = (waterFeeBasis: WaterFeeBasis) => {
//   const abbreviation =
//     waterFeeBasis === 'perTenant' || waterFeeBasis === 'metered'
//       ? 'perPersonPerMonth'
//       : 'perMonth'
//   return `€${i18n.t(`abbreviations.${abbreviation}`)}
// }

export const showParking = (parking: Parking | undefined): boolean =>
  parking ? parking !== 'no' && parking !== 'notSure' : false

const ApartmentConfirmationForm = ({
  t,
  handleSubmit,
  submitting,
  error,
  updateApartmentConfirmation,
  classes,
  isDisabled,
  isTemporaryRentPeriod,
  isFormerlyValid,
  waterFeeBasis,
  showParkingFee,
  rentPrice,
  rentPeriod,
  announcementType,
  securityDeposit,
  showSecurityDepositAmount,
  confirm,
  isSVAMember,
  isBeforeLogin,
  createdAt,
  doStepBack,
  currentStep,
  isMobile,
  beforeLogin,
  notes,
  availableUntilDate,
  availableFromDate,
  name,
  phoneNumber,
  email,
  password,
  vuokraoviCollateral
}: ApartmentConfirmationFormProps) => {
  const styles = useStyles()
  const [isEmpty, setIsEmpty] = useState(false)
  const [toMarketing, setToMarketing] = useState(false)
  const [vuokraoviCollateralAccepted, setVuokraoviCollateralAccepted] = useState(false)

  // useEffect(() => {
  //   if (beforeLogin) {
  //     const storedValue = localStorage.getItem('toMarketing');
  //     if (storedValue === null) {
  //       localStorage.setItem('toMarketing', 'true');
  //     } else {
  //       setToMarketing(storedValue === 'true');
  //     }
  //   }
  // }, [beforeLogin]);

  const handleToMarketingCheckboxChange = (event) => {
    const isChecked = event.target.checked
    setToMarketing(isChecked)

    if (isChecked) {
      setIsEmpty(false)
      localStorage.setItem('toMarketing', 'true')
    } else {
      localStorage.removeItem('toMarketing')
    }
  }

  const isBeforeLoginFlow = Boolean(beforeLogin)
  const showAnnouncementStep = isBeforeLoginFlow && currentStep === 9
  const showContractStep =
    (!isBeforeLoginFlow && currentStep === 9) ||
    (isBeforeLoginFlow && currentStep === 10)
  const showContactStep =
    (!isBeforeLoginFlow && currentStep === 10) ||
    (isBeforeLoginFlow && currentStep === 11)
  const contactStepHeadingKey = isBeforeLoginFlow
    ? currentStep === 11
      ? 'step10heading'
      : 'step9announcementHeading'
    : currentStep === 10
      ? 'step9announcementHeading'
      : 'step10heading'
  const showContactHelper = !(isBeforeLoginFlow && currentStep === 11)
  const contactSuggestHintKey =
    isBeforeLoginFlow && currentStep === 11 ? 'step11BeforeLoginHint' : 'step10Hint'

  const renderAnnouncementTypeSelector = () => (
    <Grid className={classes.containerItem} item xs={12} sm={12}>
      <Typography variant='body1' gutterBottom>
        {t('apartment.announcementType.label')}
      </Typography>
      <ReduxFormField
        name='announcementType'
        select
        required
        component={MyApartmentRadio}
        validate={[required]}
        disabled={isDisabled}
        items={getValuesAndLabels(
          AnnouncementTypeOptions,
          'announcementType'
        ).map(({ value, label }) => [value, t(label)])}
      />
    </Grid>
  )

  const handleVuokraoviCollateralAcceptedCheckboxChange = (event) => {
    const isChecked = event.target.checked
    setVuokraoviCollateralAccepted(isChecked)

    if (isChecked) {
      localStorage.setItem('vuokraoviCollateral', 'true')
    } else {
      localStorage.setItem('vuokraoviCollateral', 'false')
    }
  }

  useEffect(() => {
    if (vuokraoviCollateral === true) {
      setVuokraoviCollateralAccepted(true)
      localStorage.setItem('vuokraoviCollateral', 'true')
    } else {
      setVuokraoviCollateralAccepted(false)
      localStorage.setItem('vuokraoviCollateral', 'false')
    }
  }, [vuokraoviCollateral])

  const handleFormSubmit = (values: any) => {
    if (beforeLogin && !toMarketing) {
      setIsEmpty(true)
      return
    }

    return updateApartmentConfirmation(values)
  }

  const renderStyledCheckbox = ({ input, label, meta }: any) => (
    <>
      <FormControlLabel
        className={styles.checkboxLabel}
        control={
          <Checkbox
            checked={Boolean(input.value)}
            onChange={(event, checked) => input.onChange(checked)}
            onBlur={input.onBlur}
            color='primary'
            className={styles.checkboxControl}
          />
        }
        label={<div className={styles.checkboxText}>{label}</div>}
      />
      {meta && meta.touched && meta.error && (
        <Typography style={{ color: 'red', marginTop: '4px' }} variant='body2'>
          {meta.error}
        </Typography>
      )}
    </>
  )

  return (
    <form onSubmit={handleSubmit(handleFormSubmit)}>
      <Grid container justify='space-between'>
        <Grid container>
          {showAnnouncementStep && (
            <>
              <Grid container>
                <Grid item lg={6} md={12} sm={12} xs={12}>
                  <Grid className={classes.largeForm} container>
                    <Grid item sm={12}>
                      <Typography variant='h5' gutterBottom>
                        {t('apartment.steps.step9announcementHeading')}
                      </Typography>
                    </Grid>
                    {renderAnnouncementTypeSelector()}
                    <Grid item xs={12}>
                      <Typography
                        variant='body2'
                        className={styles.announcementInfoBox}
                      >
                        {t('apartment.announcementType.helper')}
                      </Typography>
                    </Grid>
                    <Grid item xs={12}>
                      <Typography
                        variant='body1'
                        className={styles.contactSubheading}
                      >
                        {t('apartment.announcementType.contact')}
                      </Typography>
                    </Grid>
                    <Grid
                      item
                      xs={12}
                      className={classes.containerItem}
                      style={{ marginTop: '8px', marginBottom: '24px' }}
                    >
                      <ReduxFormField
                        name='notes'
                        type='text'
                        component={MyInput}
                        validate={[isInvalidCharacters]}
                        style={{
                          width: '100%',
                          height: '58px',
                          padding: '20px',
                          background: '#E7ECEF'
                        }}
                        multiline={true}
                        disabled={isDisabled}
                      />
                    </Grid>
                    {isEmpty && (
                      <div className={classes.validationContainer}>
                        <Typography style={{ color: 'red' }} variant='body1'>
                          {t('apartment.actions.stepFail')}
                        </Typography>
                      </div>
                    )}
                    <Grid container className={`${classes.buttonContainer} ${styles.buttonGap}`}>
                      <Grid item xs={4}>
                        <BackButton
                          currentStep={currentStep}
                          doStepBack={doStepBack}
                        />
                      </Grid>
                      <Grid item xs={8}>
                        <NextStepButton
                          type='button'
                          beforeLogin={beforeLogin}
                          toValidate={{ announcementType }}
                          toCheck={{}}
                          setIsEmpty={setIsEmpty}
                        />
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
                <Grid item lg={6} md={12} sm={12} xs={12}>
                  <div className={classes.infoBoxWrapper}>
                    <Suggest
                      fullWidth
                      content={t('apartment.hints.step9AnnouncementHint')}
                    />
                  </div>
                </Grid>
              </Grid>
            </>
          )}

          {showContractStep && (
            <>
              <Grid container>
                <Grid item lg={6} md={12} sm={12} xs={12}>
                  <Grid className={classes.largeForm} container>
                    <Grid item sm={12}>
                      <Typography variant='h5' gutterBottom>
                        {t('apartment.steps.step9heading')}
                      </Typography>
                    </Grid>
                    <Grid
                      className={classes.containerItem}
                      item
                      xs={12}
                      sm={12}
                    >
                      <Typography variant='body1' gutterBottom>
                        {t('apartment.rentPeriod.label')}
                      </Typography>
                      <ReduxFormField
                        name='rentPeriod'
                        select
                        required
                        component={MyApartmentRadio}
                        validate={[required]}
                        disabled={isDisabled}
                        style={{ width: '90%' }}
                        items={getValuesAndLabels(
                          RentPeriodOptions,
                          'rentPeriod'
                        ).map(({ value, label }) => [value, t(label)])}
                      />
                    </Grid>
                    {isFormerlyValid && (
                      <Grid
                        item
                        xs={12}
                        sm={12}
                        className={classes.containerItem}
                      >
                        <Typography variant='body1' gutterBottom>
                          {t('apartment.rentPeriod.noticeTime')}
                        </Typography>
                        {/* <Field
                          fullWidth
                          name='noticeTime'
                          required
                          style={{
                            width: '100%',
                            height: '58px',
                            padding: '20px',
                            background: '#E7ECEF'
                          }}
                          component={MyInput}
                          normalize={charsSpaceNums}
                        /> */}
                        <ReduxFormField
                          name='noticeTime'
                          select
                          component={MyApartmentRadio}
                          required
                          disabled={isDisabled}
                          items={getValuesAndLabels(
                            NoticeTimeOptions,
                            'noticeTime'
                          ).map(({ value, label }) => [value, t(label)])}
                        />
                      </Grid>
                    )}
                    {isTemporaryRentPeriod && (
                      <Grid
                        item
                        xs={12}
                        sm={12}
                        className={classes.containerItem}
                      >
                        <Typography variant='body1' gutterBottom>
                          {t('apartment.availableUntilDate')}
                        </Typography>
                        <Grid item xs={12} className={classes.datePicker}>
                          <DateRangeIcon />
                          <Field
                            fullWidth
                            name='availableUntilDate'
                            invalidLabel=''
                            required
                            validate={[required, greaterThanAvailableFrom]}
                            component={ReduxDatePicker}
                          />
                        </Grid>
                      </Grid>
                    )}
                    <Grid
                      className={classes.containerItem}
                      item
                      xs={12}
                      sm={12}
                    >
                      <Typography variant='body1' gutterBottom>
                        {t('apartment.securityDeposit.label')}
                      </Typography>
                      <ReduxFormField
                        name='securityDeposit'
                        select
                        component={MyApartmentRadio}
                        required
                        disabled={isDisabled}
                        items={getValuesAndLabels(
                          SecurityDepositOptions,
                          'securityDeposit'
                        ).map(({ value, label }) => [value, t(label)])}
                      />
                      <div
                        style={{
                          background: '#FBF6EE',
                          borderRadius: 12,
                          padding: '10px 14px',
                          marginTop: 8,
                          display: 'flex',
                          alignItems: 'center'
                        }}
                      >
                        <span style={{ fontSize: 16, marginRight: 8 }}>👍</span>
                        <Typography variant='caption' style={{ color: '#4b5563' }}>
                          <strong>61 %</strong>{' '}
                          {t('apartment.securityDeposit.socialProof')}
                        </Typography>
                      </div>
                    </Grid>
                    {showSecurityDepositAmount && (
                      <Grid item xs={12} sm={12}>
                        <Typography variant='body1' gutterBottom>
                          {t('apartment.securityDepositAmount')}
                        </Typography>
                        <ReduxFormField
                          name='securityDepositAmount'
                          required
                          InputProps={{ min: 0, step: 0.01, endAdornment: '€' }}

                          disabled={isDisabled}
                          component={MyInput}
                          style={{
                            width: '100%',
                            height: '58px',
                            padding: '20px',
                            background: '#E7ECEF'
                          }}
                          type='number'
                          normalize={onlyNumsAndDecimals}
                          validate={[required]}
                        />
                      </Grid>
                    )}
                    {/* <Grid item xs={12} sm={12}>
                      <Typography variant='body1' gutterBottom>
                        {t('apartment.rentPrice')}
                      </Typography>
                      <ReduxFormField
                        name='price'
                        required
                        InputProps={{ min: 0, step: 0.01, endAdornment: '€' }}

                        disabled={isDisabled}
                        component={MyInput}
                        style={{
                          width: '100%',
                          height: '58px',
                          padding: '20px',
                          background: '#E7ECEF'
                        }}
                        type='number'
                        normalize={onlyNumsAndDecimals}
                        validate={[required]}
                      />
                    </Grid> */}
                    <FormControlLabel
                      className={`${styles.checkboxLabel} ${styles.vuokraoviCollateralCheckBoxContainer}`}
                      control={
                        <Checkbox
                          checked={vuokraoviCollateralAccepted}
                          onChange={handleVuokraoviCollateralAcceptedCheckboxChange}
                          color='primary'
                          className={styles.checkboxControl}
                        />
                      }
                      label={
                        <div className={styles.checkboxText}>
                          {t('apartment.vuokraoviCollateralCheckboxText')}
                        </div>
                      }
                    />
                  </Grid>
                  {isEmpty && (
                    <Typography style={{ color: 'red' }} variant='body1'>
                      {t('apartment.actions.stepFail')}
                    </Typography>
                  )}
                  <Grid container className={`${classes.buttonContainer} ${styles.buttonGap}`}>
                    <Grid item xs={4}>
                      <BackButton
                        currentStep={currentStep}
                        doStepBack={doStepBack}
                      />
                    </Grid>
                    <Grid item xs={8}>
                      <NextStepButton
                        type='button'
                        beforeLogin={beforeLogin}
                        toValidate={{
                          rentPeriod: rentPeriod,
                          securityDeposit: securityDeposit
                        }}
                        toCheck={{
                          availableUntilDate: availableUntilDate
                            ? availableUntilDate['_d'] < availableFromDate
                            : ''
                        }}
                        setIsEmpty={setIsEmpty}
                      />
                    </Grid>
                  </Grid>
                </Grid>
                <Grid item lg={6} md={12} sm={12} xs={12}>
                  <div className={classes.infoBoxWrapper}>
                    <Suggest
                      fullWidth
                      content={t('apartment.hints.step9Hint')}
                    />
                  </div>
                </Grid>
              </Grid>{' '}
            </>
          )}

          {showContactStep && (
            <>
              <Grid container>
                <Grid item lg={6} md={12} sm={12} xs={12}>
                  <Grid className={classes.largeForm} container>
                    <Grid item xs={12}>
                      <Typography variant='h5' gutterBottom>
                        {t(`apartment.steps.${contactStepHeadingKey}`)}
                      </Typography>
                    </Grid>
                    <Grid item container xs={12}>
                      <Grid container spacing={1}>
                        {!isBeforeLoginFlow && renderAnnouncementTypeSelector()}
                        {showContactHelper && (
                          <Grid item xs={12}>
                            <Typography
                              variant='body2'
                              className={styles.announcementInfoBox}
                            >
                              {t('apartment.announcementType.helper')}
                            </Typography>
                          </Grid>
                        )}
                        {showContactHelper && (
                          <Grid item xs={12}>
                            <Typography
                              variant='body1'
                              className={styles.contactSubheading}
                            >
                              {t('apartment.announcementType.contact')}
                            </Typography>
                          </Grid>
                        )}
                        {beforeLogin && (
                          <>
                            <Grid item sm={12}>
                              <Typography variant='subtitle2' gutterBottom>
                                {t('signup.passwordHelper')}
                              </Typography>
                            </Grid>
                            <Grid item xs={12} sm={6}>
                              <Typography variant='body1' gutterBottom>
                                {t('person.fullName')}
                              </Typography>
                              <ReduxFormField
                                name='name'
                                validate={[required, isInvalidCharacters]}
                                component={MyInput}
                                style={{
                                  width: '100%',
                                  height: '58px',
                                  padding: '20px',
                                  background: '#E7ECEF'
                                }}
                                required
                              />
                            </Grid>
                            <Grid item xs={12} sm={6}>
                              <Typography variant='body1' gutterBottom>
                                {t('person.phoneNum')}
                              </Typography>
                              <ReduxFormField
                                autoComplete='tel'
                                name='phoneNumber'
                                component={MyInput}
                                style={{
                                  width: '100%',
                                  height: '58px',
                                  padding: '20px',
                                  background: '#E7ECEF'
                                }}
                                validate={[
                                  required,
                                  noSpacesPhoneNum,
                                  validatePhoneNumber,
                                ]}
                                required
                              />
                            </Grid>
                            <Grid item xs={12} sm={12}>
                              <Typography variant='body1' gutterBottom>
                                {t('person.email')}
                              </Typography>
                              <ReduxFormField
                                autoComplete='username'
                                name='email'
                                component={MyInput}
                                style={{
                                  width: '100%',
                                  height: '58px',
                                  padding: '20px',
                                  background: '#E7ECEF'
                                }}
                                validate={[
                                  required,
                                  noSpaceValue,
                                  validateEmail
                                ]}
                                required
                              />
                            </Grid>
                            <Grid item xs={12}>
                              <Typography variant='body1' gutterBottom>
                                {t('person.password')}
                              </Typography>
                              <ReduxFormField
                                autoComplete='new-password'
                                name='password'
                                component={MyInput}
                                style={{
                                  width: '100%',
                                  height: '58px',
                                  padding: '20px',
                                  background: '#E7ECEF'
                                }}
                                type='password'
                                helperText={t('changePw.helperText')}
                                validate={[
                                  required,
                                  validatePassword,
                                  noSpaceValue
                                ]}
                                required
                              />
                            </Grid>
                          </>
                        )}
                        {!beforeLogin && (
                          <Grid item xs={12}>
                            <ReduxFormField
                              name='notes'
                              type='text'
                              component={MyInput}
                              style={{
                                width: '100%',
                                height: '58px',
                                padding: '20px',
                                background: '#E7ECEF'
                              }}
                              validate={[isInvalidCharacters]}
                              multiline={true}
                              disabled={isDisabled}
                            />
                          </Grid>
                        )}

                        <Grid item xs={12} sm={12}>
                          <div className={styles.checkboxGroup}>
                            <Field
                              name='confirm'
                              component={renderStyledCheckbox}
                              validate={[requiredCheckbox]}
                              label={
                                <>
                                  {t('apartment.confirmation.confirmPart')}
                                  <a
                                    style={{
                                      textDecoration: 'none',
                                      color: 'inherit'
                                    }}
                                    target='blank'
                                    href='https://fiksuvuokraus.fi/kayttoehdot/'
                                  >
                                    {t('apartment.confirmation.confirmPartLink1')}
                                  </a>
                                  {t('apartment.confirmation.confirmDivider')}
                                  <a
                                    style={{
                                      textDecoration: 'none',
                                      color: 'inherit'
                                    }}
                                    target='blank'
                                    href='https://fiksuvuokraus.fi/tietosuojaseloste/'
                                  >
                                    {t('apartment.confirmation.confirmPartLink2')}
                                  </a>
                                </>
                              }
                            />
                            {beforeLogin && (<>
                              <FormControlLabel
                                className={styles.checkboxLabel}
                                control={
                                  <Checkbox
                                    checked={toMarketing}
                                    onChange={handleToMarketingCheckboxChange}
                                    color='primary'
                                    className={styles.checkboxControl}
                                    disabled={isDisabled}
                                  />
                                }
                                label={
                                  <div className={styles.checkboxText}>
                                    {t('apartment.toMarketingDisclaimer')}
                                    <a
                                      style={{
                                        textDecoration: 'none',
                                        color: 'inherit'
                                      }}
                                      target='blank'
                                      href='https://fiksuvuokraus.fi/kayttoehdot'
                                    >
                                      {t('apartment.confirmation.confirmPartLinkToMarketing')}
                                    </a>
                                  </div>
                                }
                              />
                              {isEmpty && !toMarketing && (
                                <Typography style={{ color: 'red', marginTop: '4px' }} variant='body2'>
                                  {t('apartment.toMarketingRequired')}
                                </Typography>
                              )}
                            </>)}
                          </div>
                        </Grid>
                      </Grid>
                      {showParkingFee && (
                        <Grid item xs={12} lg={6}>
                          <Typography variant='body1' gutterBottom>
                            {t('apartment.parkingFee')}
                          </Typography>
                          <ReduxFormField
                            name='parkingFee'
                            type='number'
                            component={MyInput}
                            style={{
                              width: '100%',
                              height: '58px',
                              padding: '20px',
                              background: '#E7ECEF'
                            }}
                            InputProps={{
                              min: 0,
                              step: 0.01,
                              endAdornment: '€'
                            }}
                            normalize={onlyNumsAndDecimals}
                            disabled={isDisabled}
                          />
                        </Grid>
                      )}
                    </Grid>
                    <Grid item sm={12} xs={12} style={{ marginTop: '15px' }}>
                      <ErrorMessage error={error} />
                      {isEmpty && (
                        <Typography style={{ color: 'red' }} variant='body1'>
                          {t('apartment.actions.stepFail')}
                        </Typography>
                      )}
                      <Grid container>
                        <Grid item xs={4}>
                          <BackButton
                            currentStep={currentStep}
                            doStepBack={doStepBack}
                          />
                        </Grid>
                        <Grid item xs={8}>
                          <SubmitButton
                            t={t}
                            submit={!isDisabled}
                            setIsEmpty={setIsEmpty}
                            toValidate={{
                              confirm: confirm,
                              ...(beforeLogin ? { toMarketing } : {})
                            }}
                            toCheck={{
                              notes: isInvalidCharacters(notes),
                              name: isInvalidCharacters(name),
                              phoneNumber:
                                noSpacesPhoneNum(phoneNumber) ||
                                validatePhoneNumber(phoneNumber),
                              email:
                                noSpaceValue(email) || validateEmail(email),
                              password:
                                validatePassword(password) ||
                                noSpaceValue(password)
                            }}
                            externalIsLoading={submitting}
                            customLabel={
                              <> {t('apartment.actions.confirm')}</>
                            }
                          />
                        </Grid>
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
                <Grid item lg={6} md={12} sm={12} xs={12}>
                  <div className={classes.infoBoxWrapper}>
                    <Suggest
                      fullWidth
                      content={t(`apartment.hints.${contactSuggestHintKey}`)}
                    />
                  </div>
                </Grid>
              </Grid>
            </>
          )}
        </Grid>
      </Grid>{' '}
    </form>
  )
}

const selector = formValueSelector('ApartmentConfirmationForm')

const mapStateToProps = (
  state: StateInterface,
  ownProps: { isBeforeLogin: boolean }
) => {
  let apartment
  if (ownProps.isBeforeLogin) {
    apartment = selectBeforeLoginApartment(state)
  } else {
    const apartmentId = selectContentIdFromPathname(state)
    apartment = apartmentId
      ? selectApartmentById(apartmentId)(state)
      : undefined
  }
  const isSVAMemberValue = selector(state, 'isSVAMember')
  return {
    isTemporaryRentPeriod: selector(state, 'rentPeriod') === 'temporary',
    isFormerlyValid: selector(state, 'rentPeriod') === 'formerlyValid',
    waterFeeBasis: selector(state, 'waterFeeBasis'),
    showSecurityDepositAmount: selector(state, 'securityDeposit') === 'other',
    rentPrice: Number(apartment?.switchedData?.price || '0'),
    rentPeriod: selector(state, 'rentPeriod'),
    announcementType: selector(state, 'announcementType'),
    availableUntilDate: selector(state, 'availableUntilDate'),
    availableFromDate: selector(state, 'availableFromDate'),
    notes: selector(state, 'notes'),
    confirm: selector(state, 'confirm'),
    securityDeposit: selector(state, 'securityDeposit'),
    showParkingFee: showParking(apartment?.information?.parking),
    isSVAMember: isSVAMemberValue === true || isSVAMemberValue === 'true',
    isMobile: selectIsMobile(state),
    name: selector(state, 'name'),
    phoneNumber: selector(state, 'phoneNumber'),
    email: selector(state, 'email'),
    password: selector(state, 'password')
  }
}

export default connect(mapStateToProps)(
  reduxForm({
    form: 'ApartmentConfirmationForm'
  })(withTranslation()(ApartmentConfirmationForm as any) as any) as any
) as any
